import styled from 'styled-components';

export default styled.div`
  display: flex;
  cursor: default;
  user-select: none;
  justify-content: center;
  flex-wrap: wrap;
  
  p {
    margin: 5px 5px 5px 0;
    font-family: 'Fira Mono', sans-serif;
    font-size: 25px;
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
    color: #151515;
    
    &:last-of-type {
      margin-right: 0;
    }
  }
`;